import { axios } from '@Root/API'

export const edit = (id, payload) => {
	return axios.put(`attache/note/${id}/student-course-session`, payload)
}
